import React from "react";
import { Fragment } from "react";
//import { LayoutClient } from "../layouts";

import Login from "../modules/Login/Login";
import Logout from "../modules/Login/Logout";
import Register from "../modules/Login/Register";
import Votes from "../modules/VoteVotes/index";
import VotesLogin from "../modules/VoteVotes/Login";
import Results from "../modules/VoteShowResults/index";
import ResultsLogin from "../modules/VoteShowResults/Login";
/////////////admin/////////////////////////
const Dashboard = React.lazy(() => import("../modules/Dashboard/Dashboard"));
const Menu = React.lazy(() => import("../modules/Menu"));
const Module_Permission = React.lazy(() => import("../modules/Module_Permission"));
const Function_Permission = React.lazy(() => import("../modules/Function_Permission"));
const Role = React.lazy(() => import("../modules/Role"));
const Staff = React.lazy(() => import("../modules/Staff"));
const DiaryPersonal = React.lazy(() => import("../modules/DiaryPersonal"));
const User = React.lazy(() => import("../modules/User"));
const ReportAccount = React.lazy(() => import("../modules/ReportAccount"));
const Product = React.lazy(() => import("../modules/Product"));
const ProductCate = React.lazy(() => import("../modules/ProductCate"));
const Organize = React.lazy(() => import("../modules/Organize"));
const OrganizeInfo = React.lazy(() => import("../modules/OrganizeInfo"));
const CalendarWork = React.lazy(() => import("../modules/CalendarWork"));
/////////////danh muc////
const CateNationality = React.lazy(() => import("../modules/CateNationality"));
const CateReligion = React.lazy(() => import("../modules/CateReligion"));
const CateOrganize = React.lazy(() => import("../modules/CateOrganize"));
const CateEthnic = React.lazy(() => import("../modules/CateEthnic"));
const CatePositionUnion = React.lazy(() => import("../modules/CatePositionUnion"));
const CatePositionParty = React.lazy(() => import("../modules/CatePositionParty"));
const CatePositionTradeUnion = React.lazy(() => import("../modules/CatePositionTradeUnion"));
const CateLanguageCertificate = React.lazy(() => import("../modules/CateLanguageCertificate"));
const CateInformaticsCertificate = React.lazy(() => import("../modules/CateInformaticsCertificate"));
const CateFormsTraining = React.lazy(() => import("../modules/CateFormsTraining"));
const CateLog = React.lazy(() => import("../modules/CateLog"));
/////////////////////////phan mem bieu quyet/////////////////////////
////////////////bieu quyet////////////////////////////////
const VoteCateGroup = React.lazy(() => import("../modules/VoteCateGroup"));
const VoteGroup = React.lazy(() => import("../modules/VoteGroup"));
const VoteSessions = React.lazy(() => import("../modules/VoteSessions"));
const VoteChoices = React.lazy(() => import("../modules/VoteChoices"));
const VotePeople = React.lazy(() => import("../modules/VotePeople"));
const VoteResultsReport = React.lazy(() => import("../modules/VoteResultsReport"));
///////////////Tai lieu cuoc hop/////////////////////////////
const DocMeeting = React.lazy(() => import("../modules/DocMeeting"));
const DocFolder = React.lazy(() => import("../modules/DocFolder"));
const DocFile = React.lazy(() => import("../modules/DocFile"));
const DocViewFile = React.lazy(() => import("../modules/DocViewFile"));

const publicRouters = [
    /// Fragment = null layout
    { path: "/login", component: Login, layout: Fragment },
    { path: "/votes", component: Votes, layout: Fragment },
    { path: "/votes_login", component: VotesLogin, layout: Fragment },
    { path: "/results", component: Results, layout: Fragment },
    { path: "/results_login", component: ResultsLogin, layout: Fragment },
];
const privateRouters = [
    ///default layout = LayoutAdmin
    { path: "/", component: Dashboard },
    { path: "/register", component: Register },
    { path: "/logout", component: Logout },
    { path: "/role", component: Role },
    { path: "/staff", component: Staff },
    { path: "/diary_personal", component: DiaryPersonal },
    { path: "/user", component: User },
    { path: "/report_account", component: ReportAccount },
    { path: "/menu", component: Menu },
    { path: "/module_permission", component: Module_Permission },
    { path: "/function_permission", component: Function_Permission },
    { path: "/product", component: Product },
    { path: "/product_cate", component: ProductCate },
    { path: "/organize", component: Organize },
    { path: "/organize_info", component: OrganizeInfo },
    { path: "/calendar_work", component: CalendarWork },
    { path: "/nationality_cate", component: CateNationality },
    { path: "/religion_cate", component: CateReligion },
    { path: "/organize_cate", component: CateOrganize },
    { path: "/ethnic_cate", component: CateEthnic },
    { path: "/position_union_cate", component: CatePositionUnion },
    { path: "/position_party_cate", component: CatePositionParty },
    { path: "/position_trade_union_cate", component: CatePositionTradeUnion },
    { path: "/language_certificate_cate", component: CateLanguageCertificate },
    { path: "/informatics_certificate_cate", component: CateInformaticsCertificate },
    { path: "/forms_training_cate", component: CateFormsTraining },
    { path: "/log_cate", component: CateLog }, 
    //////////////phan mem bieu quyet//////////////////
    { path: "/vote_cate_group", component: VoteCateGroup },
    { path: "/vote_group", component: VoteGroup },
    { path: "/vote_sessions", component: VoteSessions }, 
    { path: "/vote_choices", component: VoteChoices }, 
    { path: "/vote_people", component: VotePeople }, 
    { path: "/vote_results", component: VoteResultsReport },
    { path: "/doc_meeting", component: DocMeeting },
    { path: "/doc_folder", component: DocFolder }, 
    { path: "/doc_file", component: DocFile },
    { path: "/doc_view", component: DocViewFile },
]; 

export { publicRouters, privateRouters };
